/* FugaX (15/10/2026): frete com data de chegada, sem exigir o número.
   Usa a mesma cotação do Macboot Fretes da calculadora padrão (macboot-product-shipping.js). */
const ENDPOINT = 'https://macboot-fretes.onrender.com/api/storefront/quotes';
const MESES = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
const MSG = {
  invalid_cep: 'Confira o CEP: são 8 números.',
  cep_not_found: 'Não encontramos esse CEP. Confira e tente de novo.',
  cep_unavailable: 'Não foi possível validar o CEP agora. Tente de novo em instantes.',
  rate_limited: 'Muitas consultas seguidas. Espere um minuto e tente de novo.',
  select_variant: 'Este produto está sem estoque para cotar o frete.',
  unavailable: 'Não foi possível calcular agora. O frete aparece no checkout.',
};

/* feriados nacionais (sem expediente dos Correios/transportadoras) até o fim de 2027 */
const FERIADOS = new Set([
  '2026-11-02', '2026-11-15', '2026-11-20', '2026-12-25',
  '2027-01-01', '2027-02-08', '2027-02-09', '2027-03-26', '2027-04-21', '2027-05-01', '2027-05-27',
  '2027-09-07', '2027-10-12', '2027-11-02', '2027-11-15', '2027-11-20', '2027-12-25',
]);
const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const addBiz = (date, n) => {
  const d = new Date(date);
  while (n > 0) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6 && !FERIADOS.has(iso(d))) n -= 1; }
  return d;
};
const dm = (d) => `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`;
const wd = (d) => d.toLocaleDateString('pt-BR', { weekday: 'long' }).replace('-feira', '');
const brl = (cents) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
const svc = (name) => String(name).replace(/\s*-?\s*\.Package/i, '').trim();
const el = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; };

class FxShipping extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.input = this.querySelector('[data-cep]');
    this.button = this.querySelector('[data-calc]');
    this.status = this.querySelector('[data-status]');
    this.out = this.querySelector('[data-out]');
    this.tbc = this.querySelector('[data-tbc]');
    this.variants = (this.dataset.variants || '').split(',').filter(Boolean).map((s) => { const [id, av] = s.split(':'); return { id, available: av === 'true' }; });
    this.input.addEventListener('input', () => {
      let v = this.input.value.replace(/\D/g, '').slice(0, 8);
      if (v.length > 5) v = `${v.slice(0, 5)}-${v.slice(5)}`;
      this.input.value = v;
    });
    this.input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); this.calculate(); } });
    this.button.addEventListener('click', () => this.calculate());
    this.freebar = this.querySelector('[data-freebar]');
    this.cartCents = 0;
    this.priceCents = this.readPrice();
    document.addEventListener('mb-fx:price', (e) => { this.priceCents = e.detail.cents; this.renderFree(); });
    this.loadCart();
    /* sacola mudou (adicionar/remover pela página ou na gaveta): recalcula; o tema atualiza o contador */
    document.querySelectorAll('[data-cart-count]').forEach((n) => new MutationObserver(() => this.loadCart()).observe(n, { childList: true, characterData: true, subtree: true }));
    window.addEventListener('pageshow', () => this.loadCart());
    this.renderFree();
  }

  readPrice() {
    const t = document.querySelector('.pdp-info .pdp-price [data-price]')?.textContent || '';
    const m = t.match(/R\$\s?([\d.]+,\d{2})/);
    return m ? Number(m[1].replace(/\./g, '').replace(',', '')) : 0;
  }

  /* mesma conta da régua da sacola: subtotal dos itens (items_subtotal_price) */
  loadCart() {
    fetch('/cart.js', { credentials: 'same-origin' }).then((r) => (r.ok ? r.json() : null)).then((cart) => {
      this.cartCents = (cart && cart.items_subtotal_price) || 0;
      this.inCart = !!(cart && (cart.items || []).some((i) => i.handle === this.dataset.handle));
      this.renderFree();
    }).catch(() => {});
  }

  /* barra do frete grátis Sul/Sudeste (R$ 499), atrelada à sacola:
     linha 1 = situação da sacola (igual à régua do carrinho); linha 2 = o que muda levando este par */
  renderFree() {
    if (!this.freebar) return;
    const LIM = 49900;
    const cart = this.cartCents || 0;
    const price = this.priceCents || 0;
    if (this.sulSudeste === false) {
      this.freebar.replaceChildren(el('p', null, 'O frete grátis acima de R$ 499 vale só para Sul e Sudeste.'));
      return;
    }
    const p = el('p', null);
    if (cart >= LIM) {
      p.append(el('b', null, 'Na sacola: frete grátis no Sul e Sudeste.'));
    } else if (cart > 0) {
      p.append('Na sacola: '); p.append(el('b', null, `faltam ${brl(LIM - cart)}`)); p.append(' para o frete grátis no Sul/Sudeste.');
      if (!this.inCart && price) {
        p.append(el('br'));
        p.append(cart + price >= LIM ? el('b', null, 'Levando este par, o frete fica grátis.') : `Com este par, faltam ${brl(LIM - cart - price)}.`);
      }
    } else if (price) {
      if (price >= LIM) p.append(el('b', null, 'Levando este par, o frete é grátis no Sul e Sudeste.'));
      else { p.append('Frete grátis no Sul e Sudeste a partir de R$ 499: '); p.append(el('b', null, `com este par, faltam ${brl(LIM - price)}`)); p.append('.'); }
    } else { this.freebar.replaceChildren(); return; }
    /* barra = sacola (igual ao carrinho); sacola vazia = este par */
    const base = cart > 0 ? cart : price;
    const bar = el('div', 'mb-fx-freebar-bar'); bar.setAttribute('aria-hidden', 'true');
    const fill = el('i'); fill.style.width = `${Math.min(100, (base / LIM) * 100).toFixed(1)}%`; bar.append(fill);
    this.freebar.replaceChildren(p, bar);
  }

  variantId() {
    const scope = document.getElementById(`shopify-section-${this.dataset.section}`);
    const chosen = scope?.querySelector('[data-product-form] [name="id"]')?.value;
    if (chosen) return String(chosen);
    const first = this.variants.find((v) => v.available);
    return first ? first.id : '';
  }

  async calculate() {
    const cep = this.input.value.replace(/\D/g, '');
    this.out.replaceChildren();
    if (this.tbc) this.tbc.hidden = true;
    if (cep.length !== 8) { this.status.textContent = MSG.invalid_cep; return; }
    const variantId = this.variantId();
    if (!variantId) { this.status.textContent = MSG.select_variant; return; }
    this.button.disabled = true;
    this.status.textContent = 'Calculando…';
    const addr = Promise.race([
      fetch(`https://viacep.com.br/ws/${cep}/json/`, { credentials: 'omit', referrerPolicy: 'no-referrer' })
        .then((r) => (r.ok ? r.json() : null)).catch(() => null),
      new Promise((ok) => { setTimeout(() => ok(null), 2500); }),
    ]);
    try {
      this.lib = this.lib || await import(this.dataset.lib);
      const rates = await this.lib.quoteProductWithDelivery({
        handle: this.dataset.handle, variantId, quantity: 1, postalCode: cep, endpoint: ENDPOINT,
      });
      this.status.textContent = '';
      if (!rates.length) { this.status.textContent = MSG.unavailable; return; }
      const a = await addr;
      this.place = a && !a.erro && a.localidade ? `${a.localidade} - ${a.uf}` : '';
      /* região pela faixa do CEP (Correios): 0-3 = Sudeste, 8-9 = Sul; não depende do ViaCEP */
      this.sulSudeste = /^[012389]/.test(cep);
      this.renderFree();
      this.render(rates);
    } catch (error) {
      this.status.textContent = MSG[error?.code] || MSG.unavailable;
    } finally {
      this.button.disabled = false;
    }
  }

  render(rates) {
    const today = new Date();
    const dispatch = addBiz(today, 1);
    const tomorrow = new Date(today); tomorrow.setDate(tomorrow.getDate() + 1);
    const opts = rates.map((r) => ({ ...r, date: addBiz(dispatch, r.deliveryDaysMax) }))
      .sort((a, b) => a.priceCents - b.priceCents || a.date - b.date);
    const best = opts[0];
    const box = el('div', 'mb-fx-sx');
    const h = el('p', 'mb-fx-sx-h', 'Chega em ');
    h.append(el('em', null, `${best.date.getDate()} de ${MESES[best.date.getMonth()]}`));
    const sub = el('p', 'mb-fx-sx-sub', 'com ');
    if (best.priceCents === 0) sub.append(el('b', null, 'Frete Grátis')); else sub.append(brl(best.priceCents));
    sub.append(` · ${svc(best.name)}${this.place ? ` · para ${this.place}` : ''}`);
    const tl = el('ol', 'mb-fx-sx-tl');
    tl.setAttribute('aria-label', 'Etapas da entrega');
    const step = (a, b) => { const li = el('li'); li.append(el('b', null, a), el('span', null, b)); return li; };
    const dispatchLabel = dispatch.toDateString() === tomorrow.toDateString() ? 'amanhã' : `${wd(dispatch)}, ${dm(dispatch)}`;
    tl.append(step('Hoje', 'pedido feito'), step(dispatchLabel, 'sai do estoque'), step(dm(best.date), 'na sua porta'));
    box.append(h, sub, tl);
    for (const o of opts) {
      const row = el('div', 'mb-fx-sx-opt');
      row.append(el('span', null, `${svc(o.name)} · ${wd(o.date)}, ${dm(o.date)}`));
      row.append(el('span', o.priceCents === 0 ? 'free' : null, o.priceCents === 0 ? 'Grátis' : brl(o.priceCents)));
      box.append(row);
    }
    box.append(el('p', 'mb-fx-sx-note', 'Previsão do Macboot Fretes: envio em até 1 dia útil mais o prazo da transportadora, sem contar fins de semana e feriados nacionais. No checkout, o prazo é calculado para o seu CEP exato.'));
    this.out.replaceChildren(box);
    if (this.tbc) this.tbc.hidden = false;
    const short = best.date.toLocaleDateString('pt-BR', { weekday: 'short' }).replace('.', '');
    document.dispatchEvent(new CustomEvent('mb-fx:quote', { detail: { label: `${short}, ${dm(best.date)}` } }));
  }
}

if (!customElements.get('mb-fx-shipping')) customElements.define('mb-fx-shipping', FxShipping);
